/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementLogsPage} from '../models/EntitlementLogsPage';
import type {Error} from '../models/Error';
import type {GrantEntitlementLogsPageRequest} from '../models/GrantEntitlementLogsPageRequest';
import type {ResourceEntitlementLogsPageRequest} from '../models/ResourceEntitlementLogsPageRequest';
import type {RoleEntitlementLogsPageRequest} from '../models/RoleEntitlementLogsPageRequest';

export interface GetGrantEntitlementLog$Request {
    grantId: string;
    grantEntitlementLogsPageRequest: GrantEntitlementLogsPageRequest;
}

export interface GetGrantEntitlementLog$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getGrantEntitlementLogRequest = createAction<PayloadData<void, GetGrantEntitlementLog$Request>>('ENTITLEMENT_LOG__GET_GRANT_ENTITLEMENT_LOG__REQUEST');
export const getGrantEntitlementLogSuccess = createAction<PayloadData<EntitlementLogsPage, GetGrantEntitlementLog$Request>>('ENTITLEMENT_LOG__GET_GRANT_ENTITLEMENT_LOG__SUCCESS');
export const getGrantEntitlementLogFailure = createAction<PayloadData<Error, GetGrantEntitlementLog$Request, true>>('ENTITLEMENT_LOG__GET_GRANT_ENTITLEMENT_LOG__FAILURE');

export const getGrantEntitlementLogActions = [
    getGrantEntitlementLogRequest,
    getGrantEntitlementLogSuccess,
    getGrantEntitlementLogFailure
] as const;

/**
 * @param {string} meta.grantId
 * @param {GrantEntitlementLogsPageRequest} meta.grantEntitlementLogsPageRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getGrantEntitlementLog = (meta: GetGrantEntitlementLog$Request, config?: GetGrantEntitlementLog$Config) => {
    return {
        CALL_API: {
            types: getGrantEntitlementLogActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/logs/grants/${meta.grantId}`,
            TRANSPORT_REQUEST_BODY: meta.grantEntitlementLogsPageRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetResourceEntitlementLog$Request {
    resourceId: string;
    resourceEntitlementLogsPageRequest: ResourceEntitlementLogsPageRequest;
}

export interface GetResourceEntitlementLog$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getResourceEntitlementLogRequest = createAction<PayloadData<void, GetResourceEntitlementLog$Request>>('ENTITLEMENT_LOG__GET_RESOURCE_ENTITLEMENT_LOG__REQUEST');
export const getResourceEntitlementLogSuccess = createAction<PayloadData<EntitlementLogsPage, GetResourceEntitlementLog$Request>>('ENTITLEMENT_LOG__GET_RESOURCE_ENTITLEMENT_LOG__SUCCESS');
export const getResourceEntitlementLogFailure = createAction<PayloadData<Error, GetResourceEntitlementLog$Request, true>>('ENTITLEMENT_LOG__GET_RESOURCE_ENTITLEMENT_LOG__FAILURE');

export const getResourceEntitlementLogActions = [
    getResourceEntitlementLogRequest,
    getResourceEntitlementLogSuccess,
    getResourceEntitlementLogFailure
] as const;

/**
 * @param {string} meta.resourceId
 * @param {ResourceEntitlementLogsPageRequest} meta.resourceEntitlementLogsPageRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getResourceEntitlementLog = (meta: GetResourceEntitlementLog$Request, config?: GetResourceEntitlementLog$Config) => {
    return {
        CALL_API: {
            types: getResourceEntitlementLogActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/logs/resources/${meta.resourceId}`,
            TRANSPORT_REQUEST_BODY: meta.resourceEntitlementLogsPageRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetRoleEntitlementLog$Request {
    roleId: string;
    roleEntitlementLogsPageRequest: RoleEntitlementLogsPageRequest;
}

export interface GetRoleEntitlementLog$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getRoleEntitlementLogRequest = createAction<PayloadData<void, GetRoleEntitlementLog$Request>>('ENTITLEMENT_LOG__GET_ROLE_ENTITLEMENT_LOG__REQUEST');
export const getRoleEntitlementLogSuccess = createAction<PayloadData<EntitlementLogsPage, GetRoleEntitlementLog$Request>>('ENTITLEMENT_LOG__GET_ROLE_ENTITLEMENT_LOG__SUCCESS');
export const getRoleEntitlementLogFailure = createAction<PayloadData<Error, GetRoleEntitlementLog$Request, true>>('ENTITLEMENT_LOG__GET_ROLE_ENTITLEMENT_LOG__FAILURE');

export const getRoleEntitlementLogActions = [
    getRoleEntitlementLogRequest,
    getRoleEntitlementLogSuccess,
    getRoleEntitlementLogFailure
] as const;

/**
 * @param {string} meta.roleId
 * @param {RoleEntitlementLogsPageRequest} meta.roleEntitlementLogsPageRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getRoleEntitlementLog = (meta: GetRoleEntitlementLog$Request, config?: GetRoleEntitlementLog$Config) => {
    return {
        CALL_API: {
            types: getRoleEntitlementLogActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/logs/roles/${meta.roleId}`,
            TRANSPORT_REQUEST_BODY: meta.roleEntitlementLogsPageRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

